import { render, staticRenderFns } from "./bindCompany.vue?vue&type=template&id=1e34dff4&scoped=true&"
import script from "./bindCompany.vue?vue&type=script&lang=js&"
export * from "./bindCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e34dff4",
  null
  
)

export default component.exports